import { render, staticRenderFns } from "./ProjectMeasure.vue?vue&type=template&id=ba2eda12"
import script from "./ProjectMeasure.vue?vue&type=script&lang=js"
export * from "./ProjectMeasure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports